import './Login.css';

import { Component } from 'react';
import { Flow } from 'flow-react';

class Login extends Component {
  state = {
    user: '',
    pass: '',
    initdone: false,
    loggedin: false,
  }

  changeInput = evt => {
    this.setState({[evt.target.name]: evt.target.value});
  }

  handleSubmit = evt => {
    evt.preventDefault();
    if (this.state.initdone)
      this.tryLogin();
    else
      this.props.flow.init()
        .then(()=>{ 
          this.setState({initdone: true});
          this.tryLogin();
        });
  }
	
	
  tryLogin = () => {
    this.props.flow.login(this.state.user,this.state.pass)
      .then(res=>{
				if(res.user.custom_permissions.MW.role == 'Kunde') 
					console.log('may not login');
				else {
					this.props.logincb({username:this.state.user,userid:res.user.getId()});
				}
      }).catch(e => {
					this.props.logincb({userid:0});
      });
  }

  render() {
		let errdiv = (this.props.errmess == '') ? null : <div className="smallerrormess">{ this.props.errmess }</div>
    return (
      <div className="component Login">
					<img src="vifogralogo.png" alt="" className="logopic" />
					<form className="form" onSubmit={this.handleSubmit}>
						<div className="row">
							<label>Login:</label>
							<input type="text" value={ this.state.user } name="user" onChange={ this.changeInput } />
						</div>
						<div className="row">
							<label>Password:</label>
							<input type="password" value={ this.state.pass } name="pass" onChange={ this.changeInput } />
						</div>
						{errdiv}
						<div className="row">
							<input className="loginsubmit" type="submit" value="Submit" />
						</div>
					</form>
      </div>
    );
  }
}

export default Flow.injectFlow(Login);